import { Container, Row, Col } from "react-bootstrap";
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

export const AboutTeaserSection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <section className="about-teaser" id="about" aria-labelledby="about-heading">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}>
                  <h2 id="about-heading">Why "Whiskey Rebel"?</h2>
                  <div className="about-body">
                    <p>Two reasons.</p>
                    <p>
                      The first was a Red Fox Lab named Whiskey Rebel I brought home from Bedford, PA at nine weeks old.
                    </p>
                    <p>
                      The second is older. In 1791, the federal government passed an excise tax on whiskey — and the small distillers, farmers, and frontiersmen of Western Pennsylvania didn't take kindly to being told what they owed by men who'd never set foot on their land. It took George Washington three years and 13,000 troops to put the rebellion down.
                    </p>
                    <p className="about-kicker">
                      Whiskey Rebel Creative is built on the same principle: stay close to the work, stay loyal to the people doing it, and don't apologize for refusing to play the corporate game.
                    </p>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
